import { render, staticRenderFns } from "./EditPageContract.vue?vue&type=template&id=6397e25e"
import script from "./EditPageContract.vue?vue&type=script&lang=js"
export * from "./EditPageContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports